module.exports = __webpack_public_path__ + "img/bg.e575a47b.png";